import actions from './actions';
import initialState from '../initialState';

export const inspectionsReducer = (state = initialState.inspections, action) => {
    switch (action.type) {
        case actions.INSPECTIONS_MODAL:
            return {
                ...state,
                inspectionsModal: action.state.inspectionsModal,
            };
        default:
            return { ...state };
    }
};

export default inspectionsReducer;
